module.exports = __webpack_public_path__ + "media/images/404-bg-mobile-b381edb9352057d4b04a247c3dc88da5.svg";